import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import FranceAgeConfirmationModal from 'components/FranceAgeConfirmationModal';

import { isFrench } from 'helpers/locales';

import { useAuth } from 'hooks/useAuth';

interface IProps {
  modalDelay: number;
}

const FranceAgeConfirmationOrchestrator = ({ modalDelay }: IProps) => {
  const { isAuthenticated } = useAuth();

  const { locale } = useIntl();

  const currentLocaleIsFrench = useMemo(() => isFrench(locale), [locale]);

  if (isAuthenticated) return null;
  if (!currentLocaleIsFrench) return null;

  return <FranceAgeConfirmationModal delay={modalDelay} />;
};

export default FranceAgeConfirmationOrchestrator;
